import script from "./SelectRoom.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectRoom.vue?vue&type=script&setup=true&lang=js"

import "./SelectRoom.vue?vue&type=style&index=0&id=a781aa90&scoped=true&lang=css"
import "./SelectRoom.vue?vue&type=style&index=1&id=a781aa90&scoped=true&lang=css"

import exportComponent from "/Users/zane/Dev/ionic-spirit/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a781aa90"]])

export default __exports__